// The line icons the product boards draw (FEWeek, PhoneWeek, FEHome, POYT, Certificate). Each takes
// the colour of the text around it; .icon-line is the shell's (shell.css).
const line = (w = 2) => ({ strokeWidth: w })

export function FileIcon({ size = 18 }) {
  return (
    <svg className="icon-line" width={size} height={size} viewBox="0 0 24 24" aria-hidden="true" style={line(1.75)}>
      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" /><path d="M14 2v6h6" />
    </svg>
  )
}

export function CopyIcon({ size = 18, stroke = 1.75 }) {
  return (
    <svg className="icon-line" width={size} height={size} viewBox="0 0 24 24" aria-hidden="true" style={line(stroke)}>
      <rect x="9" y="9" width="12" height="12" rx="2" /><path d="M5 15V5a2 2 0 0 1 2-2h10" />
    </svg>
  )
}

export function ToolIcon({ size = 18 }) {
  return (
    <svg className="icon-line" width={size} height={size} viewBox="0 0 24 24" aria-hidden="true" style={line(1.75)}>
      <rect x="4" y="2" width="16" height="20" rx="2" /><path d="M8 6h8M8 11h2M14 11h2M8 15h2M14 15h2M8 19h2M14 19h2" />
    </svg>
  )
}

export function LockLine({ size = 18 }) {
  return (
    <svg className="icon-line" width={size} height={size} viewBox="0 0 24 24" aria-hidden="true" style={line(1.75)}>
      <rect x="4" y="11" width="16" height="10" rx="2" /><path d="M8 11V7a4 4 0 0 1 8 0v4" />
    </svg>
  )
}

export function LinkIcon({ size = 16 }) {
  return (
    <svg className="icon-line" width={size} height={size} viewBox="0 0 24 24" aria-hidden="true" style={line(2)}>
      <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71" />
      <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71" />
    </svg>
  )
}

export function OutIcon({ size = 18 }) {
  return (
    <svg className="icon-line" width={size} height={size} viewBox="0 0 24 24" aria-hidden="true" style={line(1.75)}>
      <path d="M14 3h7v7" /><path d="M10 14 21 3" /><path d="M21 14v5a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5" />
    </svg>
  )
}

export function VideoIcon({ size = 18 }) {
  return (
    <svg className="icon-line" width={size} height={size} viewBox="0 0 24 24" aria-hidden="true" style={line(1.75)}>
      <rect x="2" y="6" width="14" height="12" rx="2" /><path d="m22 8-6 4 6 4z" />
    </svg>
  )
}

export function PlayFill({ size = 34 }) {
  return (
    <svg className="icon-fill" width={size} height={size} viewBox="0 0 24 24" aria-hidden="true">
      <path d="M8 5v14l11-7z" />
    </svg>
  )
}

export function Tick({ size = 15, stroke = 2.5 }) {
  return (
    <svg className="icon-line" width={size} height={size} viewBox="0 0 24 24" aria-hidden="true" style={line(stroke)}>
      <path d="M20 6 9 17l-5-5" />
    </svg>
  )
}

export function ChatIcon({ size = 16 }) {
  return (
    <svg className="icon-line" width={size} height={size} viewBox="0 0 24 24" aria-hidden="true" style={line(2)}>
      <path d="M21 12a8 8 0 0 1-11.5 7.2L3 21l1.8-6.5A8 8 0 1 1 21 12z" />
    </svg>
  )
}

export function DownloadLine({ size = 18 }) {
  return (
    <svg className="icon-line" width={size} height={size} viewBox="0 0 24 24" aria-hidden="true" style={line(2)}>
      <path d="M12 3v12M7 10l5 5 5-5M5 21h14" />
    </svg>
  )
}

export function Chevron({ size = 16, open = false }) {
  return (
    <svg className={open ? 'icon-line pp-chev pp-chev--open' : 'icon-line pp-chev'} width={size} height={size} viewBox="0 0 24 24" aria-hidden="true" style={line(2)}>
      <path d="m6 9 6 6 6-6" />
    </svg>
  )
}

// A kind's icon, for a resource card
export function KindIcon({ kind, size = 18 }) {
  if (kind === 'locked') return <LockLine size={size} />
  if (kind === 'text') return <CopyIcon size={size} />
  if (kind === 'tool') return <ToolIcon size={size} />
  if (kind === 'link') return <OutIcon size={size} />
  if (kind === 'video') return <VideoIcon size={size} />
  return <FileIcon size={size} />
}
